import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";
import { useSnackbar } from 'notistack';
import { DropzoneArea } from "material-ui-dropzone";
import { Table, TableBody, TableCell, TableHead, TableRow, Paper, Grid, Button, TextField, Dialog, DialogContent, DialogTitle, DialogActions, Tooltip, CircularProgress, Chip } from '@material-ui/core';
import { Pagination, STableLoader, PageLoader, EmptyCollection, DeletePopUp } from '../../shared_elements';
import AddInteriorItem from './AddInteriorItem'
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import GetAppIcon from '@material-ui/icons/GetApp';
import { globalGetService, globalPutService, globalPostService, globalDeleteService } from '../../../globalServices';
import { checkApiStatus, checkPermission } from '../../utils_v2';
import { downloadFile } from "../../../utils";
import RemarksDynamicField from "../../../shared/components/RemarksDynamicField";
import { trackActivity } from "../../../utils/mixpanel";
import { SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import { arrayMoveImmutable } from "array-move";
import FilePreview from "../../shared_elements/FilePreview";
import { gaTelesisInstance, mtInstance, titanAviInstance } from "../../../shared/components";
const lopaObj = {
    image: null,
    delivered_image: null,
    remarks: ''
}
const LOPAHd = () => {
    return (
        <TableHead>
            <TableRow>
                <TableCell style={{ position: 'sticky', left: 0, backgroundColor: '#B5BEDB', zIndex: 10, width: '150px' }}>Action(s)</TableCell>
                <TableCell>{(gaTelesisInstance || titanAviInstance) ? 'File Name' : 'Current Lopa'}</TableCell>
                {!(gaTelesisInstance || titanAviInstance) ? <TableCell>Delivered Lopa</TableCell> : null}
                <TableCell>Remarks</TableCell>
            </TableRow>
        </TableHead>
    )
}

const SortableBodyContainer = SortableContainer(({ lopasInfo, setAddEditLOPA, setDeleteLOPA, setViewFilesPopup, setViewLopa }) => {
    return (
        <TableBody>
            {lopasInfo.list.map((item, index) =>
                <LOPAList
                    key={`item-${index}`}
                    index={index}
                    sortIndex={index}
                    item={item}
                    onEdit={() => setAddEditLOPA({ modal: true, data: item })}
                    onDelete={() => setDeleteLOPA({ modal: true, data: item })}
                    onView={(item) =>( gaTelesisInstance || titanAviInstance) ? setViewLopa({ modal: true, data: item }) : setViewFilesPopup({ modal: true, data: item })}
                />
            )}
        </TableBody>
    );
});

const DragHandle = SortableHandle(() => <span style={{ paddingRight: '10px', display: 'inline-block', cursor: 'move', width: '10%' }}><DragIndicatorIcon /></span>)
const LOPAList = SortableElement(({ item, onEdit, onDelete, onView }) => {
    return (
        <TableRow>
            <TableCell align="left" style={{ position: 'sticky', left: 0, backgroundColor: 'inherit', zIndex: 1 }}>
                <ul className="list-inline" style={{ width: '150px' }}>
                    {item?.image?.length && (gaTelesisInstance || titanAviInstance) ?
                        <li className="list-inline-item hover-inline" onClick={() => downloadFile(item)}>
                            <Tooltip title='Download LOPA' arrow><GetAppIcon color="primary" fontSize="small" /></Tooltip>
                        </li> : null
                    }
                    {item?.image?.length || item?.delivered_image?.length ?
                        <li className="list-inline-item hover-inline" onClick={() => onView(item)}>
                            <Tooltip title='View' arrow><VisibilityIcon style={{ cursor: 'pointer' }} color='primary' fontSize='small' /></Tooltip>
                        </li> : null}
                    {
                        checkPermission('technical_specs', 'interior', 'U') ?
                            <li className="list-inline-item hover-inline" onClick={onEdit}>
                                <Tooltip title='Edit' arrow><EditIcon color="primary" fontSize="small" /></Tooltip>
                            </li>
                            : null}
                    {
                        checkPermission('technical_specs', 'interior', 'D') ?
                            <li className="list-inline-item hover-inline" onClick={onDelete}>
                                <Tooltip title='Delete' arrow><DeleteOutlineIcon color="secondary" fontSize="small" /></Tooltip>
                            </li>
                            : null}
                    <li className="list-inline-item hover-inline"><DragHandle /></li>
                </ul>
            </TableCell>
            <TableCell style={{ maxWidth: '300px' }}>{item?.file_name || '--'}</TableCell>
            {!(gaTelesisInstance || titanAviInstance) ? <TableCell style={{ maxWidth: '300px' }}>{item?.delivered_file_name || '--'}</TableCell> : null}
            <TableCell>
                <RemarksDynamicField item={item} />
            </TableCell>
        </TableRow>
    )
})
const AddEditLOPA = ({ params, addEditLOPA, toggleModalFn, getResponseBack, assetInfoData }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [lopa, setLOPA] = useState(addEditLOPA.data);
    const [error, setError] = useState({});
    const onAddEditLOPA = () => {
        let validationInputs = {};
        if (!(lopa?.image?.length || lopa?.delivered_image?.length) && mtInstance) {
            validationInputs.image = 'Please upload any one of the Lopa (Current or Delivered).';
        }
        if (!lopa?.image?.length && !mtInstance) {
            if (gaTelesisInstance || titanAviInstance) {
                validationInputs.image = 'Please upload Lopa.';
            } else {
                validationInputs.image = 'Please upload Current Lopa.';
            }
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true);
            const payload = new FormData();
            payload.append('remarks', lopa?.remarks || '');

            if (lopa?.image?.length && lopa.image[0]?.name) {
                payload.append('image', lopa.image[0]);
            }else if(!lopa?.image?.length && lopa.id) {
                payload.append('image', '');
                payload.append('file_name', '');
                payload.append('current_extension', '');
            }

            if (lopa?.delivered_image?.length && lopa.delivered_image[0]?.name) {
                payload.append('delivered_image', lopa.delivered_image[0]);
            } else if(!lopa?.delivered_image?.length && lopa.id) {
                payload.append('delivered_image', '');
                payload.append('delivered_file_name', '');
                payload.append('delivered_extension', '');
            }

            if (lopa.id) {
                globalPutService(`console/v2/${params.type}/${params.aircraft_slug}/interior/lopa/${lopa.id}/`, payload)
                    .then(response => {
                        if (checkApiStatus(response)) {
                            enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                            trackActivity('Console Management', { data:JSON.stringify(lopa), page_title: 'LOPA', asset_type: 'MSN', asset_name: assetInfoData?.serial_number, event_type: 'Item Edited', event_desc: 'Edited LOPA data from Edit LOPA form' });
                            toggleModalFn(); getResponseBack();
                        }
                        setLoading(false);
                    })
            } else {

                globalPostService(`console/v2/${params.type}/${params.aircraft_slug}/interior/lopa/`, payload)
                    .then(response => {
                        if (checkApiStatus(response)) {
                            enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                            trackActivity('Console Management', { data:JSON.stringify(lopa), page_title: 'LOPA', asset_type: 'MSN', asset_name: assetInfoData?.serial_number, event_type: 'Item Added', event_desc: 'Added LOPA data from Add LOPA form' });
                            toggleModalFn(); getResponseBack();
                        }
                        setLoading(false);
                    })
            }
        } else {
            setError(validationInputs);
        }
    }
    return (
        <Dialog open={addEditLOPA.modal} onClose={toggleModalFn} className='console-management-modal' maxWidth="md" >
            <DialogTitle id="scroll-dialog-title"> {lopa?.id ? 'Edit ' : 'Add '} LOPA </DialogTitle>
            <DialogContent dividers={true}>
                <Grid container spacing={1}>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={(gaTelesisInstance || titanAviInstance) ? 12 : 6}>
                            {!(gaTelesisInstance||titanAviInstance)?<label style={{ fontWeight: 500, color: '#000000', marginBottom: 8, fontSize: '11px', fontFamily: "Conv_IBMPlexSans-Medium" }}>Current LOPA</label>:null}
                            <DropzoneArea
                                acceptedFiles={['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/bmp', 'application/pdf']}
                                filesLimit={1}
                                maxFileSize={104857600}
                                showPreviewsInDropzone={false}
                                previewChipProps={{ style: { maxWidth: '400px', cursor: 'pointer' }, title: lopa?.image?.[0]?.name }}
                                useChipsForPreview={true}
                                showPreviews={true}
                                dropzoneText={<p style={{ fontSize: '13px' }}>Drag & Drop or Click to Upload</p>}
                                dropzoneClass="drag-drop-cnt"
                                showAlerts={['info', 'error']}
                                alertSnackbarProps={{ anchorOrigin: { vertical: 'top', horizontal: 'right' } }}
                                clearOnUnmount={true}
                                onDrop={(files) => { setLOPA({ ...lopa, image: files }); setError({ ...error, image: '' }) }}
                                onDelete={() => { setLOPA(prev => ({ ...prev, image: [], file_name: '' })) }}
                            />
                            <span style={{ fontSize: '11px' }} className='files-upload-limit' > Note : Supported extension ('.pdf, images/').</span>
                            {lopa?.id && lopa?.file_name && lopa?.image && (
                                <p><Tooltip title={lopa?.file_name}><Chip style={{ maxWidth: '400px', cursor: 'pointer' }} label={lopa?.file_name} size='small' onDelete={() => { setLOPA(prev => ({ ...prev, image: [], file_name: '' })) }} /></Tooltip></p>
                            )}
                        </Grid>
                        {!(gaTelesisInstance || titanAviInstance) ?
                        <Grid item xs={12} md={6}>
                            <label style={{ fontWeight: 500,color: '#000000', marginBottom: 8, fontSize: '11px', fontFamily: "Conv_IBMPlexSans-Medium" }}>Delivered LOPA</label>
                            <DropzoneArea
                                acceptedFiles={['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/bmp', 'application/pdf']}
                                filesLimit={1}
                                maxFileSize={104857600}
                                showPreviewsInDropzone={false}
                                useChipsForPreview={true}
                                showPreviews={true}
                                previewChipProps={{ style: { maxWidth: '400px', cursor: 'pointer' }, title: lopa?.delivered_image?.[0]?.name }}
                                dropzoneText={<p style={{ fontSize: '13px' }}>Drag & Drop or Click to Upload</p>}
                                dropzoneClass="drag-drop-cnt"
                                showAlerts={['info', 'error']}
                                alertSnackbarProps={{ anchorOrigin: { vertical: 'top', horizontal: 'right' } }}
                                clearOnUnmount={true}
                                onDrop={(files) => { setLOPA({ ...lopa, delivered_image: files }); setError({ ...error, image: '' })}}
                                onDelete={() => { setLOPA(prev => ({ ...prev, delivered_image: [], delivered_file_name: '' }))}}
                            />
                            <span style={{ fontSize: '11px' }} className='files-upload-limit' > Note : Supported extension ('.pdf, images/').</span>
                            {lopa?.id && lopa?.delivered_file_name && lopa?.delivered_image?.length > 0 && (
                                <p><Tooltip title={lopa?.delivered_file_name}><Chip style={{ maxWidth: '400px', cursor: 'pointer' }} label={lopa?.delivered_file_name} size='small' onDelete={() => { setLOPA(prev => ({ ...prev, delivered_image: [], delivered_file_name: '' })) }} /></Tooltip></p>
                            )}
                            </Grid> : null}
                        {error?.image && <p className="error-msg">{error.image ? error.image : null}</p>}
                    </Grid>
                    <Grid item md={12}>
                        <TextField
                            id='remarks'
                            label='Remarks'
                            value={lopa?.remarks || ''}
                            fullWidth
                            margin="normal"
                            multiline
                            rows={3}
                            inputProps={{ maxLength: 250 }}
                            onChange={(e) => setLOPA({ ...lopa, 'remarks': e.target.value })}
                            InputLabelProps={{ shrink: true }}
                            variant='outlined'
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button disabled={isLoading} onClick={toggleModalFn} color='primary' size='small' variant='outlined'>Cancel</Button>
                <Button disabled={isLoading} onClick={onAddEditLOPA} color='primary' size='small' variant='contained'>
                    {isLoading ? <CircularProgress size={24} /> : 'Save'}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
const LOPA = ({ params, assetInfoData }) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [filter, setFilter] = useState({});
    const [lopasInfo, setLOPAsInfo] = useState({ list: [], pagination: null });
    const [addEditLOPA, setAddEditLOPA] = useState({ modal: false, data: null });
    const [deleteLOPA, setDeleteLOPA] = useState({ modal: false, data: null });
    const [viewLopa, setViewLopa] = useState({ modal: false, data: null });
    const [viewFilesPopup, setViewFilesPopup] = useState({ modal: false, data: null });
    useEffect(() => {
        getLOPAs({per_page:50}, 'skeletonLoader');
    }, []);
    const getLOPAs = (query = {}, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
        globalGetService(`console/v2/${params?.type}/${params?.aircraft_slug}/interior/lopa/`, query)
            .then(response => {
                if (checkApiStatus(response)) {
                    setLOPAsInfo(response?.data?.data)
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
            })
    }
    const onDeleteLOPA = () => {
        setLoading(true);
        globalDeleteService(`console/v2/${params?.type}/${params?.aircraft_slug}/interior/lopa/${deleteLOPA?.data?.id}`)
            .then(response => {
                if (checkApiStatus(response)) {
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                    setDeleteLOPA({ modal: false, data: null })
                    getLOPAs({per_page: lopasInfo?.pagination?.per_page}, 'pageLoader');
                }
                setLoading(false);
            })
    }
    const onSortEnd = ({ oldIndex, newIndex }) => {
        if (oldIndex !== newIndex) {
            let newArray = arrayMoveImmutable(lopasInfo?.list, oldIndex, newIndex)
            setLoading(true)
            setLOPAsInfo({ ...lopasInfo, list: newArray })
            globalPutService(`console/v2/aircraft/${params?.aircraft_slug}/interior/lopa/reorder/`, { order_list: newArray.map(item => item.id) })
                .then(response => {
                    setLoading(false)
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                    }
                })
        }
    }
    return (
        <div style={{ padding: '0px 10px' }}>
            {skeletonLoader ? <STableLoader count={4} size={7} /> :
                <>
                    <AddInteriorItem addPermission={checkPermission('technical_specs', 'interior', 'C')} onAddItem={() => setAddEditLOPA({ modal: true, data: lopaObj })} />
                    <Paper square>
                        <div style={{height:`${window.innerHeight -  (lopasInfo?.list?.length ? 330 : 280)}px`,overflow:'auto',marginTop: "3px" }}>
                        <Table className='mui-table-format' stickyHeader>
                            <LOPAHd />
                            <SortableBodyContainer
                                useDragHandle
                                onSortEnd={onSortEnd}
                                lopasInfo={lopasInfo}
                                setAddEditLOPA={setAddEditLOPA}
                                setDeleteLOPA={setDeleteLOPA}
                                setViewFilesPopup={setViewFilesPopup}
                                setViewLopa={setViewLopa}
                            />
                        </Table>
                        {!lopasInfo?.list?.length ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
                        </div>
                    </Paper>
                    {lopasInfo?.pagination ?
                        <Paper square>
                            <Pagination
                                pagination={lopasInfo.pagination}
                                onChangePage={(event, newPage) => getLOPAs({ ...filter, page: newPage + 1, per_page: lopasInfo?.pagination.per_page }, 'pageLoader')}
                                onChangeRowsPerPage={(event) => getLOPAs({ ...filter, page: 1, per_page: event.target.value }, 'pageLoader')}
                            />
                        </Paper>
                        : null
                    }
                </>
            }
            {addEditLOPA.modal ?
                <AddEditLOPA
                    params={params}
                    assetInfoData={assetInfoData}
                    addEditLOPA={addEditLOPA}
                    toggleModalFn={() => setAddEditLOPA({ modal: false, data: null })}
                    getResponseBack={() => getLOPAs({per_page: lopasInfo?.pagination?.per_page}, 'pageLoader')}
                /> : null
            }
            {deleteLOPA.modal ?
                <DeletePopUp
                    modal={deleteLOPA.modal}
                    title='Delete LOPA'
                    content={`Are you sure, you want to Delete?`}
                    toggleModalFn={() => setDeleteLOPA({ modal: false, data: null })}
                    deleteRecordFn={onDeleteLOPA}
                /> : null
            }
            {viewLopa?.modal ?
                <FilePreview
                    downloadFile={downloadFile}
                    toggleModalFn={() => setViewLopa(false)}
                    fileInfo={viewLopa.data.fileType === 'delivered' ? { file_name: viewLopa?.data?.delivered_file_name, extension: viewLopa?.data?.delivered_extension, image: viewLopa?.data?.delivered_image } : { file_name: viewLopa?.data?.file_name, extension: viewLopa?.data?.current_extension, image: viewLopa?.data?.image }}
                /> : null
            }

            {viewFilesPopup.modal && (
                <Dialog className='console-management-modal' open={viewFilesPopup.modal} maxWidth="sm" fullWidth >
                    <DialogTitle>LOPA Files</DialogTitle>
                    <DialogContent dividers>
                        <ul className='list-inline'>
                            {viewFilesPopup.data?.image?.length && (
                                <li className='list-inline-item' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid #eee', cursor: 'pointer', marginRight: 0 }} >
                                    <Tooltip title="Preview Current LOPA" arrow>
                                        <span onClick={() => { setViewLopa({ modal: true, data: { ...viewFilesPopup?.data, fileType: 'current' } }) }} style={{ color: '#3f51b5', maxWidth: '400px', wordBreak: 'break-all' }} >
                                            {viewFilesPopup?.data?.file_name || 'Current LOPA Image'}
                                        </span>
                                    </Tooltip>
                                    <Tooltip title="Download Current LOPA" placement="bottom-end" arrow>
                                        <GetAppIcon fontSize="small" color="primary" style={{ cursor: 'pointer' }} onClick={() => downloadFile({ file_name: viewFilesPopup?.data?.file_name, extension: viewFilesPopup?.data?.current_extension, image: viewFilesPopup?.data?.image })} />
                                    </Tooltip>
                                </li>
                            )}
                            {viewFilesPopup.data?.delivered_image?.length && (
                                <li className='list-inline-item' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid #eee', cursor: 'pointer', }} >
                                    <Tooltip title="Preview Delivered LOPA" arrow>
                                        <span onClick={() => { setViewLopa({ modal: true, data: { ...viewFilesPopup?.data, fileType: 'delivered' } }) }} style={{ color: '#3f51b5', maxWidth: '400px', wordBreak: 'break-all' }} >
                                            {viewFilesPopup?.data?.delivered_file_name || 'Delivered LOPA Image'}
                                        </span>
                                    </Tooltip>
                                    <Tooltip title="Download Delivered LOPA" placement="bottom-end" arrow>
                                        <GetAppIcon fontSize="small" color="primary" style={{ cursor: 'pointer' }} onClick={() => downloadFile({ file_name: viewFilesPopup?.data?.delivered_file_name, extension: viewFilesPopup?.data?.delivered_extension, image: viewFilesPopup?.data?.delivered_image })} />
                                    </Tooltip>
                                </li>
                            )}
                        </ul>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setViewFilesPopup({ modal: false, data: null })} color="primary" size="small" variant="outlined">Close</Button>
                    </DialogActions>
                </Dialog>
            )}

            {isLoading ? <PageLoader /> : null}
        </div>
    )
}
export default withRouter(LOPA);